module.exports = __webpack_public_path__ + "img/icon_compass.70803118.svg";